import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from '@mui/material';
import { AddLocationAlt, LocationOn } from '@mui/icons-material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useEffect, useRef } from 'react';
import ClusterMap from './map/ClusterMap';
import Rooms from './rooms/Rooms';
import AddRoom from './addRoom/AddRoom';
import Protected from './protected/Protected';
import { useValue } from '../context/ContextProvider';
import StaticInfo from './info/StaticInfo';
import InfoIcon from '@mui/icons-material/Info';

const BottomNav = () => {
  const {
    state: { section },
    dispatch,
  } = useValue();

  const ref = useRef();
  useEffect(() => {
    ref.current.ownerDocument.body.scrollTop = 0;
  }, [section]);
  return (
    <Box ref={ref}>
      {
        {
          0: <ClusterMap />,
          1: <Rooms />,
          2: (
            <Protected>
              <AddRoom />
            </Protected>
          ),
          3: <StaticInfo />
        }[section]
      }
      <Paper
        elevation={3}
        sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2 }}
      >
        <BottomNavigation
          showLabels
          value={section}
          onChange={(e, newValue) =>
            dispatch({ type: 'UPDATE_SECTION', payload: newValue })
          }
          sx={{
            boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#f5f5f5',
            "& .Mui-selected": {
              backgroundColor: 'rgba(25, 118, 210, 0.1)'
            },
            "& .MuiBottomNavigationAction-root": {
              borderRadius: '5px',
              margin: '0.5rem',
              "&:hover": {
                backgroundColor: 'rgba(25, 118, 210, 0.08)'
              }
            }
          }}
        >
          <BottomNavigationAction label="Harta" icon={<LocationOn />} />
          <BottomNavigationAction label="Misiuni" icon={<AssignmentTurnedInIcon />} />
          <BottomNavigationAction label="Adauga" icon={<AddLocationAlt />} />
          <BottomNavigationAction label="Info" icon={<InfoIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default BottomNav;
